<style scoped>
    .notification-box {
        display: block;
        height: 54px;
        line-height: 54px;
        font-size: 20px;
        position: relative;
    }

    .notification-box-hint {
        display: inline-block;
        position: absolute;
        top: 18px;
        right: 10px;
        background-color: #E8543F;
        font-weight: normal;
    }
</style>

<template>
    <div>
        <a class="notification-box" href="/notification" target="_blank">
            <i class="notification-box-icon fa fa-bell-o"
               v-el:bell></i>
            <span class="notification-box-hint badge glow"
                  v-show="notificationNum"
                  v-text="notificationNum < 50 ? notificationNum : 50 "></span>
        </a>
    </div>
</template>

<script lang="babel">
    /**
     *  通知铃铛
     */
    import { accountModel } from 'bootsets/models'
    import { animationEnd } from 'core/view-constant'
    import 'imports?jQuery=jquery!lib/fly/fly'
    import jQuery from 'jquery'
    export default{
        components: {},
        props: {},
        data() {
            return {
                notificationNum: 0,
                // 铃铛位置
                bell: {
                    left: 0,
                    top: 0
                }
            }
        },
        events: {
            ['add-notification'](target) {
                const $starter = target instanceof jQuery ? target : $(target)
                const self = this
                const $flyer = $('<div class="notification-box-flyer"><i class="fa fa-bell fa-spin"><i></div>').appendTo('body')
                $flyer.fly({
                    start: {
                        left: $starter.offset().left,
                        top: $starter.offset().top
                    },
                    end: {
                        left: self.bell.left,
                        top: self.bell.top,
                        width: 20,
                        height: 20
                    },
                    onEnd: function () {
                        this.destory()
                        self.notificationNum++
                        self.$els.bell.classList.add('pulse')
                    }
                })
            }
        },
        methods: {},
        ready() {
            accountModel.getUnread().then((data) => {
                this.notificationNum = data
            })
            this.bell.left = $(this.$els.bell).offset().left
            this.bell.top = $(this.$els.bell).offset().top
            $(this.$els.bell).on(animationEnd, () => this.$els.bell.classList.remove('pulse'))
        }
    }
</script>



// WEBPACK FOOTER //
// notification-box.vue?910a10da